import { useGSAP } from "@gsap/react";
import { advantages } from "../constants";
import { animateWithGsap } from "../utils/animations";

// Pictogrammes SVG (clé = champ "icon" dans les constantes)
const icons = {
  power: (
    <path d="M13 2 4.5 13.5H11l-1 8.5L19.5 10H13l0-8Z" />
  ),
  fuel: (
    <path d="M3 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M3 12h10M16 8l3 3v6a2 2 0 0 0 2 2 2 2 0 0 0 2-2V9.5L19 5" />
  ),
  dyno: (
    <path d="M12 14a8 8 0 0 1 8 8H4a8 8 0 0 1 8-8Zm0 0 4-4M12 14V6" />
  ),
  shield: (
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Zm-3-10 2 2 4-4" />
  ),
};

const Advantages = () => {
  useGSAP(() => {
    animateWithGsap("#avantages .section-head", { y: 0, opacity: 1 });
    animateWithGsap(
      "#avantages .advantage-item",
      { y: 0, opacity: 1, stagger: 0.12 },
      { start: "top 80%" }
    );
  }, []);

  return (
    <section id="avantages" className="section-padding bg-noir-900">
      <div className="section-container">
        <div className="section-head reveal">
          <span className="eyebrow">Pourquoi nous</span>
          <h2 className="section-title">
            La <span className="text-ferrari">différence</span> se ressent
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {advantages.map((item) => (
            <div key={item.title} className="advantage-item reveal text-center sm:text-left">
              <div className="inline-flex w-14 h-14 rounded-2xl bg-ferrari/10 border border-ferrari/30 items-center justify-center text-ferrari">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {icons[item.icon]}
                </svg>
              </div>
              <h3 className="mt-5 font-display font-semibold text-lg">{item.title}</h3>
              <p className="mt-2 text-chrome-dark text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
